import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/models/environment.model';
import { PublicClientApplication, Configuration, AuthenticationResult } from '@azure/msal-browser';

@Injectable({ providedIn: 'root' })
export class OAuthService {
  private msalInstance: PublicClientApplication;
  private isInitialized = false;

  constructor(@Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration) {
    const msalConfig: Configuration = {
      auth: {
        clientId: this.environment.devOpsOAuth.clientId,
        authority: this.environment.devOpsOAuth.authority,
        redirectUri: this.environment.devOpsOAuth.redirectURL,
      },
      cache: {
        cacheLocation: 'sessionStorage',
      },
    };

    this.msalInstance = new PublicClientApplication(msalConfig);
  }

  private async ensureInitialized() {
    if (!this.isInitialized) {
      await this.msalInstance.initialize();
      this.isInitialized = true;
    }
  }

  async getToken(): Promise<string> {
    await this.ensureInitialized();

    const scopes = ['openid', 'profile', `${this.environment.devOpsOAuth.clientId}/.default`];
    const accounts = this.msalInstance.getAllAccounts();

    for (const account of accounts) {
      try {
        const result = await this.msalInstance.acquireTokenSilent({
          scopes,
          account,
          authority: this.environment.devOpsOAuth.authority,
        });
        return result.accessToken;
      } catch (error) {}
    }

    try {
      const result = await this.msalInstance.acquireTokenPopup({
        scopes,
        authority: this.environment.devOpsOAuth.authority,
        prompt: 'select_account',
      });
      return result.accessToken;
    } catch (error) {
      console.error('Popup token acquisition failed', error);
      throw error;
    }
  }
}
